export enum RRol {
	DOCENT = 'DOCENT',
	SECTIELEIDER = 'SECTIELEIDER',
	SCHOOLBREED = 'SCHOOLBREED',
	BEHEERDER = 'BEHEERDER',
	TEAMLEIDER = 'TEAMLEIDER',
	MENTOR = 'MENTOR',
	BESTUUR = 'BESTUUR',
	AANWEZIGHEID = 'AANWEZIGHEID',
}

/**
 * Vertaalt de rol enum naar de naam die de gebruiker kent.
 */
export function getRolName(rol: RRol): string {
	switch (rol) {
		case RRol.DOCENT:
			return 'Docent';
		case RRol.SECTIELEIDER:
			return 'Sectie';
		case RRol.SCHOOLBREED:
			return 'School';
		case RRol.TEAMLEIDER:
			return 'Team';
		case RRol.MENTOR:
			return 'Mentor';
		case RRol.BESTUUR:
			return 'Bestuur';
		case RRol.AANWEZIGHEID:
			return 'Aanwezigheid';
		case RRol.BEHEERDER:
			return 'Beheer';
		default:
			return '';
	}
}

/**
 * Vertaalt de rol enum naar de titel van de gebruiker, indien mogelijk.
 */
export function getRolDescription(rol: RRol | undefined): string {
	switch (rol) {
		case RRol.SCHOOLBREED:
			return 'Schoolbreed';
		case RRol.TEAMLEIDER:
			return 'Teamleider';
		case RRol.SECTIELEIDER:
			return 'Sectieleider';
		case RRol.DOCENT:
			return 'Docent';
		case RRol.MENTOR:
			return 'Mentor';
		case RRol.BESTUUR:
			return 'Bestuur';
		case RRol.AANWEZIGHEID:
			return 'Aanwezigheid';
		case RRol.BEHEERDER:
			return 'Beheerder';
		default:
			return '';
	}
}

/**
 * Vertaalt de rol enum naar de de afkortingsletter van de rol
 */
export function getRolShort(rol: RRol): string {
	switch (rol) {
		case RRol.DOCENT:
			return 'D';
		case RRol.SECTIELEIDER:
			return 'SL';
		case RRol.SCHOOLBREED:
			return 'SB';
		case RRol.BEHEERDER:
			return '*';
		case RRol.TEAMLEIDER:
			return 'T';
		case RRol.MENTOR:
			return 'M';
		case RRol.BESTUUR:
			return 'B';
		case RRol.AANWEZIGHEID:
			return 'A';
	}
}

/**
 * Vertaalt de rol enum naar de uitleg die de rol-switcher op de startpagina toont.
 */
export function getRolUitleg(rol: RRol | undefined): string {
	switch (rol) {
		case RRol.BESTUUR:
			return 'Je ziet gegevens van alle vestigingen binnen je bestuur';
		case RRol.SCHOOLBREED:
			return 'Je ziet alleen gegevens van je eigen vestiging(en)';
		case RRol.TEAMLEIDER:
			return 'Je ziet alleen gegevens van jouw afdeling(en)';
		case RRol.SECTIELEIDER:
			return 'Je ziet alleen gegevens van vakken binnen jouw sectie(s)';
		case RRol.DOCENT:
			return 'Je ziet alleen gegevens van de klassen en leerlingen die jij zelf lesgeeft';
		case RRol.MENTOR:
			return 'Je ziet alleen gegevens van klassen en leerlingen die jij zelf begeleidt';
		case RRol.AANWEZIGHEID:
			return 'Je ziet alleen aanwezigheidsgegevens van leerlingen op jouw vestiging(en)';
		default:
			return '';
	}
}
